module.exports = __webpack_public_path__ + "static/media/havana-6.37466be5.jpg";